import { useSchema } from "@/pages/quotes/ProgressiveFields";
import { Section } from "@/components/common";
import { MaterialNeed } from "./MaterialNeed";

const pretty = (k) => { const s = k.replace(/_mm$/, " (mm)").replace(/_pct$/, " (%)").replace(/_/g, " "); return s.charAt(0).toUpperCase() + s.slice(1); };
const blank = (v) => v === "" || v === null || v === undefined || (Array.isArray(v) && !v.length) || (typeof v === "object" && !Array.isArray(v) && !Object.keys(v).length);
const optLabel = (f, v) => (f?.options || []).map((o) => (typeof o === "object" ? o : { value: o, label: o })).find((o) => String(o.value) === String(v))?.label;

function text(v, f) {
  if (typeof v === "boolean") return v ? "Yes" : "No";
  if (Array.isArray(v)) return v.map((x) => (x && typeof x === "object" ? x.label || x.name || x.code || Object.values(x).join(" ") : optLabel(f, x) || String(x))).join(", ");
  if (v && typeof v === "object") return Object.entries(v).filter(([, x]) => !blank(x)).map(([k, x]) => `${pretty(k)}: ${text(x)}`).join(" · ");
  return optLabel(f, v) || String(v);
}

export function JobSpecs({ j, children }) {
  const schema = useSchema(j.service_line, j.job_type);
  const defs = Object.fromEntries([...(schema?.form_fields || []), ...(schema?.finishing_options || []).flatMap((o) => o.fields || [])].map((f) => [f.field_key, f]));
  const { fields = {}, finishing, job_type, ...rest } = j.specs || {};
  const rows = [...Object.entries(rest), ...Object.entries(fields || {}), ["finishing", finishing]].filter(([k, v]) => !blank(v) && !["width_mm", "length_mm"].includes(k));
  return (
    <Section title="Specs" className="lg:col-span-2" testId="job-specs">
      <dl className="grid gap-x-6 gap-y-1 p-5 text-sm sm:grid-cols-2">
        {rows.length === 0 && <p className="text-slate-400" data-testid="job-specs-empty">No specs recorded.</p>}
        {rows.map(([k, v]) => { const f = defs[k]; return (
          <div key={k} className="flex justify-between gap-2" data-testid={`job-spec-${k}`}>
            <dt className="text-slate-500">{f?.label || pretty(k)}</dt>
            <dd className="text-right font-medium">{text(v, f)}{f?.unit && typeof v !== "object" ? ` ${f.unit}` : ""}</dd>
          </div>); })}
      </dl>
      <MaterialNeed jobId={j.id} />
      {children}
    </Section>
  );
}
